import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const responseSchema = yup.object({
  emails: yup.array().of(yup.string().email()).required(),
});

const composeResponse = (res) => {
  const emails = res?.data?.data?.leads_notification_email || "";

  return {
    emails: emails
      .split(",")
      .map((email) => email.trim())
      .filter(Boolean),
  };
};

export const useLeadNotificationEmailsQuery = (options = {}) => {
  return useQuery(
    [QUERY_KEYS.leadsNotificationEmails],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getLeadsNotificationEmails());
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
};
